// src/v3/currency/swiss-franc.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CurrencySwissFrancIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CurrencySwissFrancIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M18 3.75H7.25V15.8H6c-.41 0-.75.34-.75.75s.34.75.75.75h1.25v2.2c0 .41.34.75.75.75s.75-.34.75-.75v-2.2H10c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.75v-4.95h5.65c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.75v-4.1H18c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z"
  }
) });

export {
  CurrencySwissFrancIcon
};
